const changeHeader = (pageSelector) => {

	let page = document.querySelector(pageSelector),		
		header = document.querySelector('header .container');		

	if(page) {
		header.style.position = 'fixed';
	}
}
export default changeHeader;